module.exports = __webpack_public_path__ + "static/media/wheelchair.3e1c0609.svg";